import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import HeroBanner from "./components/HeroBanner";
import SearchExercises from "./components/SearchExercises";
import Exercises from "./components/Exercises";
import { exerciseOptions, fetchData } from "../../utils/fetchData";
import { useLocation, useOutletContext } from "react-router-dom";

const Home = () => {
  const { allExercises } = useOutletContext();
  const [bodyPart, setBodyPart] = useState("all");
  const [exercises, setExercises] = useState([]);
  const [bodyParts, setBodyParts] = useState([]);
  const [search, setSearch] = useState("");

  const { search: bp } = useLocation();

  useEffect(() => {
    const querySearch = new URLSearchParams(bp);
    const queryBodyPart = querySearch.get("bp") ? querySearch.get("bp") : "all";
    setBodyPart(queryBodyPart);
  }, [bp]);

  useEffect(() => {
    const fetchExerciseBodyParts = async () => {
      const fetchBodyParts = await fetchData(
        "https://exercisedb.p.rapidapi.com/exercises/bodyPartList",
        exerciseOptions
      );
      if (fetchBodyParts) {
        setBodyParts(["all", ...fetchBodyParts]);
      }
    };

    fetchExerciseBodyParts();
  }, []);

  return (
    <Box>
      <HeroBanner />
      <SearchExercises
        setExercises={setExercises}
        allExercises={allExercises}
        bodyPart={bodyPart}
        bodyParts={bodyParts}
        search={search}
        setSearch={setSearch}
      />
      <Exercises exercises={exercises} search={search} />
    </Box>
  );
};

export default Home;
